import styled from 'styled-components'

export const UpgradeParagraph = styled.p`
  margin-top: ${({ theme }) => theme.space[1]}px;
`
